module.exports = __webpack_public_path__ + "static/grill-8de8a0b35998bd5e2d3f815ecbb01004.jpg";